import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import Form from "@Components/Form";
import ShopContact from "./ShopContact";
import eightAxios from "configs/axiosConfig";
import {
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  URLS,
  ZONE_FETCH_URL,
} from "configs/constants";
import { useNotifyContext } from "@Components/Notify";
import { COMPANY_FETCH_URL } from "configs/constants";

const initialValues = {
  name: "",
  image: null,
  company: "",
  zone: "",
  region: "",
  estate: "",
  free_text: "",
  active: false,
};

const ShopEditForm = () => {
  const [contacts, setContacts] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableZone, setDisableZone] = useState(true);

  const params = useParams();
  const history = useHistory();
  const setNotify = useNotifyContext();

  useEffect(() => {
    eightAxios
      .get(`shop/${params.id}/`)
      .then((response) => {
        const contactsData = response.data.contacts;
        const modifiedContacts = contactsData.map((contact) => ({
          ...contact,
          confirmed: true,
        }));
        setContacts(modifiedContacts);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

  const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };
  const formFields = [
    {
      type: "input",
      name: "name",
      label: "Shop Name",
      required: true,
    },
    {
      type: "fileupload",
      name: "image",
      label: "Image",
      supportedTypes: ["png", "jpg", "jpeg"],
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
      gridSize: {
        lg: 4,
      },
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      required:true,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      gridSize: {
        lg: 4,
      },
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      required:true,

      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
      gridSize: {
        lg: 4,
      },
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      required:true,

      paginated: true,
      disabled:disableEstate,
      gridSize: {
        lg: 4,
      },
      optionsDependsOn: "region",
    },
    {
      type: "input",
      multiline: true,
      rows: 3,
      name: "free_text",
      label: "Free Text",
      gridSize: {
        lg: 7,
      },
    },
    {
      type: "switch",
      name: "active",
      label: "Active?",
      labelLeft: "No",
      labelRight: "Yes",
    },

    { type: "title", title: "Contact Number", required: true },
    {
      type: "component",
      component: ShopContact,
      contacts: contacts,
      setContacts: setContacts,
      gridSize: { xs: 12 },
    },
  ];

  const submitHandler = (values, { setSubmitting }) => {
    let submitVal;
    let keys = Object.keys(values);
    let data = new FormData();
    keys.forEach((key) => {
      if (Array.isArray(values[key])) {
        values[key].forEach((value) => {
          data.append(key, value);
        });
      } else {
        if (values[key] !== null) data.append(key, values[key]);
      }
    });

    let notConfirmedContactDetected = false;
    contacts.forEach((contact) => {
      if (!contact.confirmed) {
        notConfirmedContactDetected = true;
      }
    });

    if (notConfirmedContactDetected) {
      setNotify({
        isOpen: true,
        message:
          "Please confirm the unconfirmed contact changes or remove the contact.",
        type: "error",
      });
      setSubmitting(false);
      return;
    }

    for (let i = 0, valuePair; (valuePair = contacts[i]); i++)
      for (let j in valuePair) data.append(j, valuePair[j]);
    submitVal = data;

    eightAxios
      .patch(`shop/${params.id}/`, submitVal)
      .then((response) => {
        console.log(response);
        setSubmitting(false);
        history.push(URLS.KEDAI_LIST);
      })
      .catch((error) => {
        setErrorMsg(error.response.data);
        setSubmitting(false);
      });
  };

  const formButtons = ["save", "cancel"];
  return (
    <Form
      submitUrl="shop/"
      listRoute={URLS.KEDAI_LIST}
      initialValues={initialValues}
      outerSubmitHandler={submitHandler}
      errorFromOuterComponent={errorMsg}
      formButtons={formButtons}
      formFields={formFields}
      formTitle="Contact List"
    />
  );
};

export default ShopEditForm;
